var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',[_c('mdb-row',[_c('mdb-card-title',[_c('strong',[_vm._v(" Configure this station")])])],1),_c('mdb-row',[_c('StationConfig')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }